"use strict";
/**
 * Document API Response Contracts (GH#21)
 *
 * Shapes the backend returns. Per `api-contracts.md`:
 *   - Date fields are ISO 8601 strings (server converts Date → ISO at the mapper layer).
 *   - Use Public → View → Admin inheritance where it adds value.
 */
Object.defineProperty(exports, "__esModule", { value: true });
